import styled from "@emotion/styled";
import { Button, IconButton, Typography } from "@mui/material";
import { mediumMobile, mobile } from "commons/styled.components";
import { COLORS } from "utils/colors";

export const DialogContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.5rem 2.5rem 2rem;
  background: #ffffff;
  border-radius: 1rem;
  position: relative;
  max-width: 25rem;
  text-align: center;

  ${mobile(`
    padding: 2.25rem 1.75rem 1.75rem;
  `)}

  ${mediumMobile(`
    padding: 1.75rem 1.25rem 1.5rem;
  `)}
`;

export const DialogCloseButton = styled(IconButton)`
  height: 1.75rem;
  width: 1.75rem;
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  color: #a1a1a1;
`;

export const IconBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background: rgba(21, 138, 115, 0.1);
  margin-bottom: 1.25rem;
`;

export const HeadingText = styled(Typography)`
  font-weight: 600;
  font-size: 1.25rem;
  color: #101010;
  line-height: 1.4;

  ${mobile(`
    font-size: 1.4rem;
  `)}
`;

export const SubheadingText = styled(Typography)`
  font-style: normal;
  font-weight: 400;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #6b6b6b;
  margin-top: 0.625rem;

  ${mobile(`
    font-size: 1rem;
  `)}
`;

export const PrimaryButton = styled(Button)`
  border-radius: 4px;
  padding: 0.38rem 1rem;
  margin: 0px;
  font-size: 0.86rem;
  font-weight: 500;
  text-transform: none;
  border: 1px solid ${COLORS.BRAND_DEFAULT_COLOR};
  color: #ffffff;
  background-color: ${COLORS.BRAND_DEFAULT_COLOR};

  :hover {
    background-color: #117a63;
    border-color: #117a63;
  }
`;

export const SecondaryButton = styled(Button)`
  border-radius: 4px;
  padding: 0.38rem 1rem;
  margin: 0px;
  font-size: 0.86rem;
  font-weight: 500;
  text-transform: none;
  border: 1px solid #d6d6d6;
  color: #4a4a4a;
  background-color: #ffffff;

  :hover {
    background-color: #f2f2f2;
    border-color: #b8b8b8;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: 0.75rem;
  margin-top: 1.75rem;

  ${mediumMobile(`
    flex-direction: column-reverse;
    gap: 0.625rem;
  `)}
`;
